import React from "react";
import { CheckSquare, ChevronDown, Image as ImageIcon, Upload } from "lucide-react";
import { PALETTE_GROUPS } from "../../../../store/formsSlice";

function PaletteIcon({ icon }) {
  if (icon === "H1" || icon === "H2" || icon === "B" || icon === "T") {
    return (
      <span className="mb-1 text-xl font-bold text-gray-700">{icon}</span>
    );
  }
  const Icon =
    icon === "dropdown"
      ? ChevronDown
      : icon === "checkbox"
        ? CheckSquare
        : icon === "logo"
          ? ImageIcon
          : Upload;
  return <Icon className="mb-1 h-6 w-6 text-gray-600" />;
}

export default function CustomizationPalette({
  onSelect,
  disabledTypes = [],
}) {
  return (
    <aside className="w-56 shrink-0 text-left">
      <h3 className="mb-6 text-base font-medium text-[#1D2739]">Customization</h3>
      {PALETTE_GROUPS.map((group) => (
        <div key={group.id} className="mb-8">
          <p className="mb-3 text-sm text-[#A5A5A5]">{group.label}</p>
          <div className="grid grid-cols-2 gap-3">
            {group.items.map((item) => {
              const disabled = disabledTypes.includes(item.id);
              return (
                <button
                  key={item.id}
                  type="button"
                  disabled={disabled}
                  onClick={() => onSelect(item.id)}
                  className="flex flex-col items-center justify-center rounded-lg bg-[#F9F9F9] p-3 text-center text-xs text-gray-600 transition hover:bg-blue-50 disabled:cursor-not-allowed disabled:opacity-40"
                >
                  <PaletteIcon icon={item.icon} />
                  <span>{item.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </aside>
  );
}
